module.exports = __webpack_public_path__ + "img/structure_1.49d45d1c.png";